const stats = [
  { value: '20+', label: 'Years as a DJ', icon: 'ri-headphone-line' },
  { value: '140+', label: '5-Star Reviews', icon: 'ri-star-fill' },
  { value: '1000+', label: 'Events Performed', icon: 'ri-music-2-line' },
  { value: '100%', label: 'Insured & Reliable', icon: 'ri-shield-check-line' },
];

const eventTypes = [
  { label: 'Weddings', icon: 'ri-heart-line' },
  { label: 'Corporate Events', icon: 'ri-building-line' },
  { label: 'School Dances', icon: 'ri-graduation-cap-line' },
  { label: 'Private Parties', icon: 'ri-vip-crown-line' },
  { label: 'Game Shows', icon: 'ri-gamepad-line' },
  { label: 'Karaoke Nights', icon: 'ri-mic-line' },
];

export default function AIAnswerBlock() {
  return (
    <section id="about" className="bg-[#0D0D0D] border-y border-white/8 py-28 md:py-36 relative overflow-hidden">
      <div className="absolute right-0 top-0 w-[500px] h-full bg-[radial-gradient(ellipse_at_right,_#D4AF3705_0%,_transparent_60%)] pointer-events-none"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-start">

          {/* Left — stats */}
          <div className="lg:w-[36%]">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-px bg-[#D4AF37]"></div>
              <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">About Us</span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-black text-white leading-tight mb-10"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Who Is<br />
              <em className="text-[#D4AF37] not-italic">Bugsie</em><br />
              Productions?
            </h2>

            <div className="grid grid-cols-2 gap-4">
              {stats.map(s => (
                <div key={s.label} className="bg-[#111111] border border-white/6 rounded-xl p-5">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#D4AF37]/10 mb-3">
                    <i className={`${s.icon} text-[#D4AF37] text-lg`}></i>
                  </div>
                  <div className="text-white font-black text-2xl mb-0.5" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</div>
                  <div className="text-gray-500 text-xs tracking-wide">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — answer */}
          <div className="lg:w-[64%]">
            <div className="relative bg-[#111111] border border-white/8 rounded-2xl p-8 md:p-10">
              <div className="absolute -top-3.5 left-8 bg-[#D4AF37] text-black text-[10px] font-bold px-4 py-1.5 rounded-full tracking-widest uppercase">
                About Bugsie Productions
              </div>

              <div className="text-[#D4AF37]/15 text-9xl font-serif leading-none -mt-2 mb-2 select-none">&ldquo;</div>

              <p className="text-gray-200 text-lg leading-relaxed mb-5">
                Bugsie Productions is Seattle's premier <strong className="text-white">DJ &amp; entertainment company</strong> — specializing in weddings, corporate events, school dances, photo booths, karaoke, and interactive game shows.
              </p>
              <p className="text-gray-400 text-base leading-relaxed mb-5">
                Based in <strong className="text-white">Everett, Washington</strong> and serving the greater Seattle and Puget Sound region since 2001, Bugsie Productions brings high-energy performances, professional sound systems, and a crowd-reading expertise that keeps guests on the dance floor all night long.
              </p>
              <p className="text-gray-400 text-base leading-relaxed mb-8">
                With over 20 years of experience and 140+ five-star reviews on WeddingWire and Yelp, their team handles everything from the first consultation to the final song — so you can be fully present while Bugsie handles every detail of your entertainment.
              </p>

              {/* Event types */}
              <div className="pt-6 border-t border-white/8">
                <p className="text-gray-600 text-xs tracking-widest uppercase mb-4">Events We Serve</p>
                <div className="flex flex-wrap gap-3">
                  {eventTypes.map(e => (
                    <div key={e.label} className="flex items-center gap-2 bg-[#0A0A0A] border border-white/8 rounded-full px-4 py-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className={`${e.icon} text-[#D4AF37] text-xs`}></i>
                      </div>
                      <span className="text-gray-400 text-xs font-medium">{e.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
